import { FC, ReactNode } from "react";
import { styled } from "@mui/material";

type Props = {
  children?: ReactNode;
  margin?: string;
};

const ErrorMessage: FC<Props> = ({ children, margin }) => {
  return <ErrorMessageStyled margin={margin}>{children}</ErrorMessageStyled>;
};

export default ErrorMessage;

const ErrorMessageStyled = styled("p")`
  color: ${({ theme }) => theme.error.danger};
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin: ${({ margin }: Props) => margin || "3px 14px 0"};
`;
